import { render, staticRenderFns } from "./IconAccount.vue?vue&type=template&id=2873ee00"
import script from "./IconAccount.vue?vue&type=script&lang=js"
export * from "./IconAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports